
const $ = require('./main.js');

$(document).ready(function ($) {

  if ($.support.pjax) {
    $.pjax.defaults.timeout = 30000;

    $(document).on('click', '.js-drive-real-change-tab a', function (event) {
      event.preventDefault();
      $('.js-drive-real-change-tab').removeClass('active');
      $(this).parent().addClass('active');
      var containerSelector = '.js-drive-real-change-section';
      var url = $(this).attr('href');
      $.pjax.reload(containerSelector, {
        url: url,
        fragment: containerSelector
      });
      $(this).parent().addClass('active');
    });
    $('.js-drive-real-change-section').on('pjax:complete', function () {

      $('.js-toggle').removeClass('active');
      $("#categories").removeClass('active');
    });

    $(document).on('click', '.js-drive-real-change-sub-tab a', function (event) {
      event.preventDefault();
      $('.js-drive-real-change-sub-tab').removeClass('active');
      $(this).parent().addClass('active');
      var containerSelector = '.js-drive-real-change-sub-section';
      var url = $(this).attr('href');
      $.pjax.reload(containerSelector, {
        url: url,
        fragment: containerSelector
      })
    });
    $('.js-drive-real-change-sub-section').on('pjax:complete', function () {

    });


  }

});
